import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AppVersionUseCase } from '@/app/_core/application/version/version.use-cases';
import { PlycaUiButtonGenericComponent } from '@plyca/ui-library';

@Component({
  selector: 'plyca-new-version',
  templateUrl: './new-version.component.html',
  styleUrls: ['./new-version.component.scss'],
  standalone: true,
  imports: [CommonModule, DialogModule, PlycaUiButtonGenericComponent, TranslateModule]
})
export class NewVersionComponent {
  private readonly _appVersionUseCase = inject(AppVersionUseCase);

  public isOpen = this._appVersionUseCase.selectNewVersionAvailableSig;

  public later(): void {
    this._appVersionUseCase.acknowledgeNewVersion();
  }

  public reload(): void {
    window.location.reload();
  }
}
